// Yofis — контракт API `yofis.v1`. Узел: публичные сведения о сервере компании.
//
// Всё, что можно узнать без аккаунта, — здесь (§1.12 документа 12): домен, версия,
// возможности, лимиты, провайдеры входа, брендинг. Обнаружение узла клиентом — вне Connect:
// `GET https://<domain>/.well-known/yofis` → `{ "node": { "domain", "connect_url", "version" } }`,
// запасной путь — DNS SRV `_yofis._tcp.<domain>` (§2, §6).

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/node.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/node.proto.
 */
export const file_yofis_v1_node: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Запрос сведений об узле; полей нет.
 *
 * @generated from message yofis.v1.GetNodeInfoRequest
 */
export type GetNodeInfoRequest = Message<"yofis.v1.GetNodeInfoRequest"> & {
};

/**
 * Describes the message yofis.v1.GetNodeInfoRequest.
 * Use `create(GetNodeInfoRequestSchema)` to create a new message.
 */
export const GetNodeInfoRequestSchema: GenMessage<GetNodeInfoRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 0);

/**
 * Ответ со сведениями об узле.
 *
 * @generated from message yofis.v1.GetNodeInfoResponse
 */
export type GetNodeInfoResponse = Message<"yofis.v1.GetNodeInfoResponse"> & {
  /**
   * Сведения об узле.
   *
   * @generated from field: yofis.v1.NodeInfo node = 1;
   */
  node?: NodeInfo | undefined;
};

/**
 * Describes the message yofis.v1.GetNodeInfoResponse.
 * Use `create(GetNodeInfoResponseSchema)` to create a new message.
 */
export const GetNodeInfoResponseSchema: GenMessage<GetNodeInfoResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 1);

/**
 * Сведения об узле (сервере компании).
 *
 * @generated from message yofis.v1.NodeInfo
 */
export type NodeInfo = Message<"yofis.v1.NodeInfo"> & {
  /**
   * Домен узла — часть адресов пользователей `localpart@domain` (ADR-004).
   *
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * Отображаемое имя компании/узла.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Версия сервера (semver).
   *
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * Что узел умеет; выключенное отвечает `CAPABILITY_DISABLED`.
   *
   * @generated from field: yofis.v1.Capabilities capabilities = 4;
   */
  capabilities?: Capabilities | undefined;

  /**
   * Лимиты узла; клиент проверяет до отправки.
   *
   * @generated from field: yofis.v1.Limits limits = 5;
   */
  limits?: Limits | undefined;

  /**
   * Включённые провайдеры входа — по ним клиент рисует экран входа.
   *
   * @generated from field: repeated yofis.v1.IdentityProvider identity_providers = 6;
   */
  identityProviders: IdentityProvider[];

  /**
   * Ссылка на условия использования узла (показывается при входе); пусто — не показывать.
   *
   * @generated from field: string terms_url = 7;
   */
  termsUrl: string;

  /**
   * Ссылка на политику конфиденциальности; пусто — не показывать.
   *
   * @generated from field: string privacy_url = 8;
   */
  privacyUrl: string;

  /**
   * Минимальная поддерживаемая версия клиента (semver); клиент старее — просит обновиться.
   *
   * @generated from field: string min_client_version = 9;
   */
  minClientVersion: string;

  /**
   * Брендинг узла (ADR-027): читают все, до входа.
   *
   * @generated from field: yofis.v1.Branding branding = 10;
   */
  branding?: Branding | undefined;

  /**
   * Интервал пульса в стриме событий, секунды (0.8): 10–55, по умолчанию 25. Клиент считает от него порог
   * переподключения — разрыв после двух пропущенных пульсов. Узел за прокси с коротким `proxy_read_timeout`
   * ставит меньшее значение, иначе прокси рвёт соединение раньше, чем приходит очередной пульс.
   *
   * @generated from field: int32 heartbeat_seconds = 11;
   */
  heartbeatSeconds: number;
};

/**
 * Describes the message yofis.v1.NodeInfo.
 * Use `create(NodeInfoSchema)` to create a new message.
 */
export const NodeInfoSchema: GenMessage<NodeInfo> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 2);

/**
 * Брендинг узла — как интерфейс выглядит для сотрудников этой компании (ADR-027).
 *
 * @generated from message yofis.v1.Branding
 */
export type Branding = Message<"yofis.v1.Branding"> & {
  /**
   * Публичный URL логотипа компании (`GET /branding/logo`, PNG/SVG); пусто — клиент показывает знак Yofis.
   *
   * @generated from field: string logo_url = 1;
   */
  logoUrl: string;

  /**
   * Акцент интерфейса по умолчанию для всех сотрудников.
   *
   * @generated from field: yofis.v1.Accent accent = 2;
   */
  accent: Accent;

  /**
   * Могут ли сотрудники выбирать свой акцент («Настройки → Оформление»).
   *
   * @generated from field: bool allow_user_accent = 3;
   */
  allowUserAccent: boolean;

  /**
   * Шрифт интерфейса по умолчанию для всех сотрудников (0.11, ADR-028).
   *
   * @generated from field: yofis.v1.Font font = 4;
   */
  font: Font;

  /**
   * Могут ли сотрудники выбирать свой шрифт («Настройки → Оформление»).
   *
   * @generated from field: bool allow_user_font = 5;
   */
  allowUserFont: boolean;
};

/**
 * Describes the message yofis.v1.Branding.
 * Use `create(BrandingSchema)` to create a new message.
 */
export const BrandingSchema: GenMessage<Branding> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 3);

/**
 * Возможности узла. Выключенная возможность → `CAPABILITY_DISABLED` (unimplemented) на соответствующих методах.
 *
 * @generated from message yofis.v1.Capabilities
 */
export type Capabilities = Message<"yofis.v1.Capabilities"> & {
  /**
   * Звонки (`CallService`; ADR-011, обновление 1 пилота).
   *
   * @generated from field: bool calls = 1;
   */
  calls: boolean;

  /**
   * Встречи по ссылке для внешних (`MeetingService`, v2).
   *
   * @generated from field: bool meetings = 2;
   */
  meetings: boolean;

  /**
   * Гости без аккаунта (`AuthService.JoinAsGuest`, v1.5).
   *
   * @generated from field: bool guests = 3;
   */
  guests: boolean;

  /**
   * Федерация с другими узлами (v2; ADR-008).
   *
   * @generated from field: bool federation = 4;
   */
  federation: boolean;

  /**
   * Секретные чаты E2EE (ADR-019, v2+).
   *
   * @generated from field: bool secret_chats = 5;
   */
  secretChats: boolean;

  /**
   * Загрузка файлов (`FileService`).
   *
   * @generated from field: bool file_uploads = 6;
   */
  fileUploads: boolean;

  /**
   * Справочник сотрудников (`UserService.SearchUsers`); гости справочник не видят.
   *
   * @generated from field: bool user_directory = 7;
   */
  userDirectory: boolean;

  /**
   * Опросы (`MessageKind.POLL`, `VotePoll`, `ClosePoll`).
   *
   * @generated from field: bool polls = 8;
   */
  polls: boolean;

  /**
   * Разовая геоточка (`MessageKind.LOCATION`).
   *
   * @generated from field: bool locations = 9;
   */
  locations: boolean;

  /**
   * Live-геолокация (`Location.live_until`, `UpdateLiveLocation`; v2).
   *
   * @generated from field: bool live_locations = 10;
   */
  liveLocations: boolean;

  /**
   * Истории / лента компании (`StoryService`, по решению автора).
   *
   * @generated from field: bool stories = 11;
   */
  stories: boolean;

  /**
   * Стикеры (`AttachmentKind.STICKER`, `StickerService`, v3).
   *
   * @generated from field: bool stickers = 12;
   */
  stickers: boolean;

  /**
   * Серверный полнотекстовый поиск (0.7, ADR-029). Выключен — клиент ищет только в своей локальной базе.
   * При включённом индексе тексты сообщений дополнительно хранятся на сервере в открытом виде;
   * это осознанный выбор компании, см. `NodeSettings.search_index`.
   *
   * @generated from field: bool search_server = 13;
   */
  searchServer: boolean;

  /**
   * Push-уведомления (ADR-012). Означает **способность** узла будить устройства: он ходит к шлюзу
   * и умеет себя ему назвать. Клиент с `false` не предлагает настройки уведомлений и ничего
   * не обещает: в закрытом контуре исходящие запрещены постоянно, уведомлений о новых сообщениях
   * там не будет вообще, и это решённое свойство продукта, а не временная беда.
   *
   * Признак **не мигает** вслед за сетью: шлюз, который сейчас не отвечает, — происшествие
   * для самопроверки, а не изменение возможностей. Интерфейс, дрожащий вместе с сетью, заставляет
   * человека думать, что функция то появляется, то исчезает, — это хуже честного «пушей тут нет».
   *
   * @generated from field: bool push = 14;
   */
  push: boolean;
};

/**
 * Describes the message yofis.v1.Capabilities.
 * Use `create(CapabilitiesSchema)` to create a new message.
 */
export const CapabilitiesSchema: GenMessage<Capabilities> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 4);

/**
 * Лимиты узла; превышение — invalid_argument с соответствующей причиной.
 *
 * @generated from message yofis.v1.Limits
 */
export type Limits = Message<"yofis.v1.Limits"> & {
  /**
   * Максимальная длина текста сообщения в символах (`MESSAGE_TOO_LONG`).
   *
   * @generated from field: int32 max_message_chars = 1;
   */
  maxMessageChars: number;

  /**
   * Максимальный размер файла в байтах (`FILE_TOO_LARGE`).
   *
   * @generated from field: int64 max_file_bytes = 2;
   */
  maxFileBytes: bigint;

  /**
   * Максимум вложений в одном сообщении (`TOO_MANY_ATTACHMENTS`).
   *
   * @generated from field: int32 max_attachments = 3;
   */
  maxAttachments: number;

  /**
   * Максимум участников группы.
   *
   * @generated from field: int32 max_group_members = 4;
   */
  maxGroupMembers: number;
};

/**
 * Describes the message yofis.v1.Limits.
 * Use `create(LimitsSchema)` to create a new message.
 */
export const LimitsSchema: GenMessage<Limits> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 5);

/**
 * Провайдер входа, включённый администратором (ADR-004).
 *
 * @generated from message yofis.v1.IdentityProvider
 */
export type IdentityProvider = Message<"yofis.v1.IdentityProvider"> & {
  /**
   * Идентификатор провайдера; передаётся в `AuthService.BeginOidcLogin`.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Тип.
   *
   * @generated from field: yofis.v1.IdentityProviderType type = 2;
   */
  type: IdentityProviderType;

  /**
   * Подпись кнопки на экране входа («Войти через Keycloak»).
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * Провайдер по умолчанию — клиент предлагает его первым.
   *
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;
};

/**
 * Describes the message yofis.v1.IdentityProvider.
 * Use `create(IdentityProviderSchema)` to create a new message.
 */
export const IdentityProviderSchema: GenMessage<IdentityProvider> = /*@__PURE__*/
  messageDesc(file_yofis_v1_node, 6);

/**
 * Шрифт интерфейса из фиксированного набора (`design/tokens/README.md`, ADR-028): все под OFL, субсеты
 * в поставке. Произвольный шрифтовый файл админ не загружает — это лицензионный и безопасностный риск.
 * Неизвестное клиенту значение трактуется как ONEST.
 *
 * @generated from enum yofis.v1.Font
 */
export enum Font {
  /**
   * Не задан — клиент использует ONEST.
   *
   * @generated from enum value: FONT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Onest (по умолчанию): кириллица «с рождения», совпадает со словесным знаком.
   *
   * @generated from enum value: FONT_ONEST = 1;
   */
  ONEST = 1,

  /**
   * Golos Text.
   *
   * @generated from enum value: FONT_GOLOS = 2;
   */
  GOLOS = 2,

  /**
   * Manrope.
   *
   * @generated from enum value: FONT_MANROPE = 3;
   */
  MANROPE = 3,

  /**
   * Inter.
   *
   * @generated from enum value: FONT_INTER = 4;
   */
  INTER = 4,

  /**
   * IBM Plex Sans.
   *
   * @generated from enum value: FONT_PLEX = 5;
   */
  PLEX = 5,
}

/**
 * Describes the enum yofis.v1.Font.
 */
export const FontSchema: GenEnum<Font> = /*@__PURE__*/
  enumDesc(file_yofis_v1_node, 0);

/**
 * Акцент интерфейса из фиксированного набора (`design/tokens/colors.json`, ADR-027).
 * Неизвестное клиенту значение трактуется как TEAL. Произвольный hex — бэклог.
 *
 * @generated from enum yofis.v1.Accent
 */
export enum Accent {
  /**
   * Не задан — клиент использует TEAL.
   *
   * @generated from enum value: ACCENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Морская волна (по умолчанию).
   *
   * @generated from enum value: ACCENT_TEAL = 1;
   */
  TEAL = 1,

  /**
   * Индиго.
   *
   * @generated from enum value: ACCENT_INDIGO = 2;
   */
  INDIGO = 2,

  /**
   * Сирень.
   *
   * @generated from enum value: ACCENT_LILAC = 3;
   */
  LILAC = 3,

  /**
   * Малина.
   *
   * @generated from enum value: ACCENT_RASPBERRY = 4;
   */
  RASPBERRY = 4,

  /**
   * Охра.
   *
   * @generated from enum value: ACCENT_OCHRE = 5;
   */
  OCHRE = 5,

  /**
   * Графит.
   *
   * @generated from enum value: ACCENT_GRAPHITE = 6;
   */
  GRAPHITE = 6,
}

/**
 * Describes the enum yofis.v1.Accent.
 */
export const AccentSchema: GenEnum<Accent> = /*@__PURE__*/
  enumDesc(file_yofis_v1_node, 1);

/**
 * Тип провайдера входа.
 *
 * @generated from enum yofis.v1.IdentityProviderType
 */
export enum IdentityProviderType {
  /**
   * Не задан.
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Логин (адрес, localpart или e-mail) + пароль на узле.
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_PASSWORD = 1;
   */
  PASSWORD = 1,

  /**
   * OpenID Connect (Keycloak, Google Workspace, Яндекс ID…).
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_OIDC = 2;
   */
  OIDC = 2,

  /**
   * SAML 2.0.
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_SAML = 3;
   */
  SAML = 3,

  /**
   * LDAP / Active Directory (проверка пароля и синхронизация справочника).
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_LDAP = 4;
   */
  LDAP = 4,

  /**
   * Одноразовый код по телефону (для гостей — v1.5; для сотрудников — только второй фактор).
   *
   * @generated from enum value: IDENTITY_PROVIDER_TYPE_PHONE_OTP = 5;
   */
  PHONE_OTP = 5,
}

/**
 * Describes the enum yofis.v1.IdentityProviderType.
 */
export const IdentityProviderTypeSchema: GenEnum<IdentityProviderType> = /*@__PURE__*/
  enumDesc(file_yofis_v1_node, 2);

/**
 * Публичные сведения об узле. Уровень доступа всех методов — public (без заголовков).
 *
 * @generated from service yofis.v1.NodeService
 */
export const NodeService: GenService<{
  /**
   * Домен, версия, возможности, лимиты, провайдеры входа, тексты условий, брендинг.
   * Уровень: public. Клиент вызывает до входа и кэширует; пересчитывает при `min_client_version`.
   *
   * @generated from rpc yofis.v1.NodeService.GetNodeInfo
   */
  getNodeInfo: {
    methodKind: "unary";
    input: typeof GetNodeInfoRequestSchema;
    output: typeof GetNodeInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_node, 0);

